var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 1)?_c('div',{staticClass:"batch-actions"},[_c('b-overlay',{staticClass:"d-inline-block",attrs:{"show":_vm.loading,"rounded":"","opacity":"0.6","spinner-small":""}},[_c('b-button',{staticClass:"bttn bttn--lg bttn--blue",attrs:{"variant":"danger","size":"sm"},on:{"click":_vm.deleteLocalAll}},[_vm._v(" Delete ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }